export default __webpack_public_path__ + "static/media/plus.d3e45bb0.svg";